/**
 * @desc 充值列表导出
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.TigerBalmTopUpQueryConditions): Promise<BaseResponse<defs.ResultBean>> {
  return fetch({
    url: config.API_HOST + '/elecCard/wjy/exportFile',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
